/**
 * Logo — identité visuelle officielle de Mon Ministère.
 * Carré arrondi avec croix dorée + nom (Mon en clair / Ministère en or) + tagline optionnelle.
 */
import { colors, fonts, goldGradient, TAGLINE } from "../styles/tokens";

const SIZES = {
  sm: { box: 36, cross: 18, name: 18, tagline: 11 },
  md: { box: 48, cross: 24, name: 24, tagline: 12 },
  lg: { box: 64, cross: 32, name: 32, tagline: 13 },
  xl: { box: 80, cross: 40, name: 40, tagline: 14 },
};

export default function Logo({
  size = "md",
  showName = true,
  showTagline = false,
  centered = false,
  style = {},
}) {
  const s = SIZES[size] || SIZES.md;

  const wrapper = {
    display: "flex",
    alignItems: "center",
    gap: showName ? "12px" : "0",
    flexDirection: centered ? "column" : "row",
    textAlign: centered ? "center" : "left",
    ...style,
  };

  const iconBox = {
    width: s.box,
    height: s.box,
    minWidth: s.box,
    borderRadius: `${Math.round(s.box * 0.22)}px`,
    background: goldGradient,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 6px 20px rgba(228, 167, 44, 0.35)",
    color: colors.bg,
    fontSize: `${s.cross}px`,
    fontWeight: 700,
    lineHeight: 1,
  };

  return (
    <div style={wrapper}>
      <div style={iconBox} aria-hidden="true">
        ✝
      </div>
      {showName && (
        <div style={{ display: "flex", flexDirection: "column", lineHeight: 1.05 }}>
          <span
            style={{
              fontFamily: fonts.heading,
              fontWeight: 700,
              fontSize: `${s.name}px`,
              color: colors.text,
              letterSpacing: "-0.01em",
            }}
          >
            Mon{" "}
            <span style={{ color: colors.gold }}>Ministère</span>
          </span>
          {showTagline && (
            <span
              style={{
                fontFamily: fonts.body,
                fontSize: `${s.tagline}px`,
                color: colors.textMuted,
                marginTop: centered ? "8px" : "4px",
                fontWeight: 500,
                letterSpacing: "0.01em",
              }}
            >
              {TAGLINE}
            </span>
          )}
        </div>
      )}
    </div>
  );
}
